import { render, staticRenderFns } from "./l1.vue?vue&type=template&id=495fc8ac&"
import script from "./l1.vue?vue&type=script&lang=js&"
export * from "./l1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports